import { render, staticRenderFns } from "./yi-authorize.vue?vue&type=template&id=7200e9cf&scoped=true&"
import script from "./yi-authorize.vue?vue&type=script&lang=js&"
export * from "./yi-authorize.vue?vue&type=script&lang=js&"
import style0 from "./yi-authorize.vue?vue&type=style&index=0&id=7200e9cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7200e9cf",
  null
  
)

component.options.__file = "src/components/yi-authorize/yi-authorize.vue"
export default component.exports